import { useEffect, useRef } from 'react';
import { useLazyLoad } from './use-lazy-load';
import { IPost } from '../types/interfaces/post';

const fetchNewsCount = 10;

export function useLazyLoadPosts(useLazyGet: () => any, userId?: string) {
  const { items, footerRef, resetAll } = useLazyLoad(
    useLazyGet,
    { userId, pageSize: fetchNewsCount },
    (currentItems: IPost[]) => {
      const lastPost = currentItems[currentItems.length - 1];
      const lastTimestamp = lastPost
        ? new Date(lastPost.createdAt).valueOf()
        : undefined;

      return { timestamp: lastTimestamp };
    },
    !userId,
  );
  const previousUserIdRef = useRef(userId);

  useEffect(() => {
    if (userId !== previousUserIdRef.current) {
      previousUserIdRef.current = userId;
      resetAll(!!userId);
    }
  }, [resetAll, userId]);

  return { items: (items as IPost[] | null) ?? [], footerRef };
}
